<template>
  <c-base-dialog
      v-model="isShow"
      :option="dialogOption"
      @close="close"
      v-transfer-dom
  >
    <template slot="body">
      <div class="ceiba-user-login-container">
        <div :class="isMobile ? 'ceiba-user-login-title' : 'ceiba-user-login-title-pc'">{{ options.header }}</div>
        <div :class="isMobile ? 'ceiba-user-login-list' : 'ceiba-user-login-list-pc'">
          <div :class="isMobile ? 'ceiba-user-login-item' : 'ceiba-user-login-item-pc'">
            <img
                @click="wxLogin"
                src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginWx.png"
                :class="[
                    isMobile ? 'ceiba-user-login-icon' : 'ceiba-user-login-icon-pc',
                    isDisableWXLogin ? 'ceiba-user-login-disabled-login' : ''
                    ]"
            />
            <div
                :class="[
                    isMobile ? 'ceiba-user-login-btn-text' : 'ceiba-user-login-btn-text-pc',
                    isDisableWXLogin ? 'ceiba-user-login-disabled-login' : ''
                    ]"
            >
              微信登录
            </div>
            <div
                :class="isMobile ? 'ceiba-user-login-current-status' : 'ceiba-user-login-current-status-pc'"
                v-show="currentAccTypeIsWX">
              （当前）
            </div>
          </div>
          <div :class="isMobile ? 'ceiba-user-login-item' : 'ceiba-user-login-item-pc'">
            <img
                @click="qqLogin"
                src="https://game.gtimg.cn/images/tgclub/act/vipmb_new/loginQq.png"
                :class="[
                    isMobile ? 'ceiba-user-login-icon' : 'ceiba-user-login-icon-pc',
                    isDisableQQLogin ? 'ceiba-user-login-disabled-login' : ''
                    ]"
             />
            <div
                :class="[
                    isMobile ? 'ceiba-user-login-btn-text' : 'ceiba-user-login-btn-text-pc',
                    isDisableQQLogin ? 'ceiba-user-login-disabled-login' : ''
                    ]"
            >
              QQ登录
            </div>
            <div
                :class="isMobile ? 'ceiba-user-login-current-status' : 'ceiba-user-login-current-status-pc'"
                v-show="currentAccTypeIsQQ">
              （当前）
            </div>
          </div>
        </div>
      </div>
    </template>
  </c-base-dialog>
</template>

<script>
import CDialog from '../base-dialog';
import { LOGIN_WITH_BOTH, LOGIN_ONLY_WITH_QQ, LOGIN_ONLY_WITH_WX }  from './constant';
import Vue from 'vue';
import common from '../../common';
import handlerImposeLoginType from './handlerImposeLoginType';

export default {
  name: 'user-login-popup',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    option: {
      type: Object,
      default: () => ({}),
    },
    imposeLoginType: {
      type: Number,
      default: LOGIN_WITH_BOTH,
    },
    needWXLogin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: true,
    };
  },
  computed: {
    isMobile() {
      return common.platform.isMobile;
    },
    // 弹窗模式（切换登录弹窗,OR默认登录弹窗）
    mode() {
      const { mode = 'default' } = this.option;
      return mode;
    },
    header() {
      if (this.mode === 'change') {
        return '切换登录方式';
      }
      return '请登录账号';
    },
    options() {
      return  Object.assign({
        header: this.header,
        // cid: '', // 当前组件cid
        // uid: '', // 当前组件uid
        // uname: '', // 当前组件uname
        // mode: 'default',
      }, this.option);
    },
    dialogOption() {
      return {
        footer: false,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        maskClickable: false,
        closeLocation: 'top-right',
        width: this.isMobile ? '6rem' : '600px',
        height: this.isMobile ? '3.7rem' : '350px',
        dialogStyle: {
          borderRadius: this.isMobile ? '0.24rem' : '24px',
        },
        closeStyle: {
          backgroundImage: 'url(https://game.gtimg.cn/images/tgclub/act/vipmb_new/close.png)',
          width: this.isMobile ? '0.48rem' : '48px',
          height: this.isMobile ? '0.48rem' : '48px',
          right: this.isMobile ? '-0.2rem' : '-20px',
          top: this.isMobile ? '-0.7rem' : '-70px',
        },
      };
    },
    /**
     * 根据各场景（红包，端游，微信内，浏览器内），判断当前登录类型
     * @returns {number}
     */
    imposeLogin() {
      const { imposeLoginType, needWXLogin } = this;
      return handlerImposeLoginType({ imposeLoginType, needWXLogin });
    },
    // 是否禁止微信登录
    isDisableWXLogin() {
      if (this.imposeLogin === LOGIN_WITH_BOTH) {
        return false;
      }
      if (this.imposeLogin === LOGIN_ONLY_WITH_WX) {
        return false;
      }
      return true;
    },
    // 是否禁止QQ登录
    isDisableQQLogin() {
      if (this.imposeLogin === LOGIN_WITH_BOTH) {
        return false;
      }
      if (this.imposeLogin === LOGIN_ONLY_WITH_QQ) {
        return false;
      }
      return true;
    },
    // 当前登录账号类型
    currentAccType() {
      if (!Vue.prototype?.$storeInstance?.state?.isLogin) {
        return '';
      }
      return Vue.prototype?.$storeInstance?.state?.userInfo?.acctype;
    },
    currentAccTypeIsWX() {
      return this.currentAccType === 'wx';
    },
    currentAccTypeIsQQ() {
      return this.currentAccType === 'qc';
    },
  },
  mounted() {
    document.body.style.overflowY = 'hidden';
    this.initialize();
  },
  beforeDestroy() {
    document.body.style.overflowY = '';
  },
  methods: {
    initialize() {
      this.reportExposeFunc('show_pop', { pop_name: 'login_pop' });
    },
    wxLogin() {
      if (this.isDisableWXLogin) {
        return;
      }
      if (Vue.prototype?.$eventBus?._events['ceiba:common:events:click-login']) {
        Vue.prototype.$eventBus.$emit('ceiba:common:events:click-login', { loginType: 'wx' });
        return;
      }
      Vue.prototype?.$login.login({
        loginType: 'wx',
      });
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'wx' });
      this.reportClickFunc();
    },
    qqLogin() {
      if (this.isDisableQQLogin) {
        return;
      }
      if (Vue.prototype?.$eventBus?._events['ceiba:common:events:click-login']) {
        Vue.prototype.$eventBus.$emit('ceiba:common:events:click-login', { loginType: 'qq' });
        return;
      }
      Vue.prototype?.$login.login({
        loginType: 'qq',
      });
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'qq' });
      this.reportClickFunc();
    },
    close() {
      this.reportFunc('click_pop', { pop_name: 'login_pop', type: 'close' });
      this.$emit('close');
    },
    reportClickFunc() {
      if (
        typeof Vue.prototype?.$storeInstance?._actions?.reportClick[0]
          === 'function'
      ) {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || 'base_login_pop',
        };
        console.log('reportFunc reportClick.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClick[0](params);
      }
    },
    reportFunc(eventKey, eventData) {
      if (
        typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0]
          === 'function'
      ) {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || 'base_login_pop',
          eventKey,
          eventData,
        };
        console.log('reportFunc reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
    reportExposeFunc(eventKey, eventData) {
      if (typeof Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0] === 'function') {
        const params = {
          ceibaComponentId: `${this.options.cid || ''}`,
          ceibaComponentUid: this.options.uid || '',
          ceibaComponentUname: this.options.uname || 'base_login_pop',
          eventType: 1001,
          eventKey,
          eventData,
        };
        console.log('reportExposeFunc reportClickRaw.params', params);
        Vue.prototype?.$storeInstance?._actions?.reportClickRaw[0](params);
      }
    },
  },
};
</script>

<style>
.ceiba-user-login-container{
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ceiba-user-login-title {
  width: 100%;
  height: 1.3rem;
  font-weight: 500;
  font-size: 0.32rem;
  line-height: 1.45rem;
  text-align: center;
  color: #242424;
}
.ceiba-user-login-list {
  display: flex;
  justify-content: space-between;
  width: 3.66rem;
}
.ceiba-user-login-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1.15rem;
}
.ceiba-user-login-item .ceiba-user-login-icon{
  width: 1rem;
  height: 1rem;
}
.ceiba-user-login-item .ceiba-user-login-btn-text{
  color: #000;
  font-size: 0.28rem;
  padding-top: 0.16rem;
}
.ceiba-user-login-item .ceiba-user-login-current-status{
  color: #bdbdc8;
  font-weight: 400;
  font-size: .22rem;
  line-height: .3rem;
  text-align: center;
}
.ceiba-user-login-disabled-login{
  opacity: 0.2;
  cursor: no-drop;
}
.ceiba-user-login-title-pc {
  width: 100%;
  height: 80px;
  font-weight: 500;
  font-size: 32px;
  line-height: 60px;
  text-align: center;
  color: #242424;
}
.ceiba-user-login-list-pc {
  display: flex;
  justify-content: space-between;
  width: 366px;
}
.ceiba-user-login-item-pc{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 115px;
}
.ceiba-user-login-item-pc .ceiba-user-login-icon-pc{
  width: 100px;
  height: 100px;
}
.ceiba-user-login-item-pc .ceiba-user-login-current-status-pc{
  color: #bdbdc8;
  font-weight: 400;
  font-size: 22px;
  line-height: 30px;
  text-align: center;
}
.ceiba-user-login-item-pc .ceiba-user-login-btn-text-pc{
  color: #000;
  font-size: 28px;
  padding-top: 16px;
}
</style>
